import { of, tap, fromEvent, switchMap, finalize, merge, BehaviorSubject } from 'rxjs';

import { replaceViewContainer, renderTemplate } from './view.js';
import { createDish } from './api.js';

export function createEditDishView(dishId = null) {
    return of(undefined).pipe(
        switchMap(() => {
            let root = renderTemplate('edit-dish-view');
            root.querySelector('.view-title').textContent =
                dishId === null ? 'Gericht anlegen' : 'Gericht bearbeiten';
            replaceViewContainer(root);

            let form = root.querySelector('form');

            let saving$ = new BehaviorSubject(false);

            let submit$ = fromEvent(form, 'submit').pipe(
                tap((event) => event.preventDefault()),
                switchMap(() => {
                    saving$.next(true);
                    return of(undefined).pipe(
                        switchMap(() => {
                            let title = form.title.value;
                            return createDish({
                                title,
                            });
                        }),
                        tap(() => {
                            history.back();
                        }),
                        finalize(() => saving$.next(false))
                    );
                })
            );

            let disableForm$ = saving$.pipe(
                tap((disabled) => {
                    for (let el of root.querySelectorAll('input, button')) {
                        el.disabled = disabled;
                    }
                })
            );

            return merge(submit$, disableForm$);
        })
    );
}
